<div class="row row--primary">
  <div class="col-12 mt-2">
    <teilrecht-back-link (back)="back()" label="teilrecht-page.teilrecht-home.link-back" />
  </div>
  @if (model?.announcement) {
    <div class="row row--primary tile">
      <div class="col-12 mt-2 opacity-container" [class.active]="model.announcement">
        <div class="row">
          <div class="col-12">
            <h5
              [innerHTML]="
                'teilrecht-page.teilrecht-home.title'
                  | transloco
                    : {
                        name: model.announcement.bzrBezeichnung,
                        isin: model.announcement.bzrIsin,
                      }
              "
            >
              &nbsp;
            </h5>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 mb-2">
            @if (model.announcement.letzterWeisungstermin | isFutureDate) {
              <div
                [innerHTML]="
                  'teilrecht-page.teilrecht-home.hint'
                    | transloco
                      : {
                          bestandAktieBezeichnung: model.announcement.bestandAktieBezeichnung,
                          bestandAktieIsin: model.announcement.bestandAktieIsin,
                          letzterWeisungstermin: model.announcement.letzterWeisungstermin | date: 'dd.MM.yyyy H:mm',
                          bezugAktieBezeichnung: model.announcement.bezugAktieBezeichnung,
                          bezugAktieIsin: model.announcement.bezugAktieIsin,
                        }
                "
              ></div>
              <div class="row d-flex align-items-center mt-4">
                <div class="col-lg-6">
                  <web-design-system-button [fullwidth]="true" (click)="loadPreview('sell')">
                    {{ 'teilrecht-page.teilrecht-home.link-sell' | transloco | uppercase }}
                  </web-design-system-button>
                </div>
                <div class="col-lg-6 text-center mt-2 mt-lg-0">
                  <a (click)="loadPreview('buy')" class="link-secondary text-default cursor-pointer">
                    {{ 'teilrecht-page.teilrecht-home.link-buy' | transloco }}
                  </a>
                </div>
              </div>
            } @else {
              <div
                class="mb-3"
                [innerHTML]="
                  'teilrecht-page.teilrecht-home.expired-hint'
                    | transloco
                      : {
                          name: model.announcement.bzrBezeichnung,
                          isin: model.announcement.bzrIsin,
                          expirationDate: model.announcement.letzterWeisungstermin | date: 'dd.MM.yy H:mm',
                          underlyingName: model.announcement.bezugAktieBezeichnung,
                          underlyingIsin: model.announcement.bezugAktieIsin,
                        }
                "
              ></div>
              <div class="d-flex justify-content-center">
                <web-design-system-button
                  type="secondary"
                  size="small"
                  [routerLink]="commonRoutes.postlogin.member_home"
                  [attr.aria-label]="'teilrecht-page.teilrecht-home.link-expired' | transloco"
                >
                  <span [innerHTML]="'teilrecht-page.teilrecht-home.link-expired' | transloco"></span>
                </web-design-system-button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
